import React, {Component} from 'react';
import {Step,StepList} from '@react/react-spectrum/StepList';
import {ContentMap} from '../config/contentMap';
import {MakeButton, ButtonMap, ButtonMapRenewal, ButtonMapRenewalRegistered, ButtonsOnDemand} from '../content/Common/CommonButtonsComp';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
//import { incrementStage, decrementStage, nextButtonUpdate,is_saving } from '../storeManagement/action';
import { incrementStage, decrementStage, nextButtonUpdate } from '../storeManagement/action';
import { isButtonVisibleToggle, isSavingToggle } from '../../actions/commonActions';

// i18n
import { Translate } from 'react-redux-i18n';
import './commonPage.css';
// import geoPolData from '../config/geoPolData.json';
import { Grid, GridRow, GridColumn } from '@react/react-spectrum/Grid';
import Wait from '@react/react-spectrum/Wait';

//Laguage Selector
import store from '../../store';
import { disableLanguageSelectorToggle } from '../../actions/commonActions';
import { setLocaleWithFallback } from '../../actions/index';
import { preferredLanguageName } from '../../i18n/config';
import { getContractDates } from '../../utils/contractDates';


class RenewalPage extends Component{

    state = {
        formInitialized : false
    }

    componentDidMount() { 
        let initFields = {};
        if (this.props.partnerData) {
            initFields = { ...this.props.partnerData.partnerInfo,
                ...this.getGeo(this.props.partnerData.partnerInfo.billingCountry),
                ...this.props.partnerData.specializationInfo,
                ...getContractDates(
                    this.props.partnerData.partnerInfo.anniversaryDate,
                    this.props.partnerData.partnerInfo.contractStartDate,
                ),
                iCertify: this.props.partnerData.draftLevel ? true : false,
                draftLevel: this.props.partnerData.partnerInfo.level === "Gold Certified" ? "Gold" : this.props.partnerData.partnerInfo.level,
                showRetailFocusQues:this.props.partnerData.showRetailFocusQues,
                context: "Renewal"}
        }
        //iCertify check above
        if(this.props.partnerData.contactInfo && this.props.partnerData.contactInfo.preferredLanguage)
        {
            this.setLang(this.props.partnerData.contactInfo.preferredLanguage);
        }
        this.props.initialize(initFields);
        this.setState({ formInitialized: true});
    }

    setLang = (lang) => {
        const finalLocale = Object.keys(preferredLanguageName).includes(lang)
                    ? preferredLanguageName[lang] : 'en_US';
            store.dispatch(setLocaleWithFallback(finalLocale));
            store.dispatch(disableLanguageSelectorToggle(true));
    }

    getGeo = (billingCountry) => {
        let retObj = { "geo": "" }
        Object.keys(this.props.geoPolData).map(key => {
            let obj = this.props.geoPolData[key];
            if (obj.countries.hasOwnProperty(billingCountry)) {
                retObj.geo = obj.value;

            }
            return null;
        })
        return retObj;
    }

    render(){
        const currentStage = this.props.currentStage;
        var TAG = this.props.partnerData.partnerInfo.level === "Registered" ? ContentMap['renewalFormsRegistered'][currentStage] : ContentMap['renewalForms'][currentStage];
        var allbuttonFunc = {
            "onNextButton" : this.props.onNextButton,
            "onPreviousButton" : this.props.onPreviousButton,
            "onSubmitButton" : this.props.onSubmitButton,
        }
        
        var buttonRowNo = (this.props.isSaveAndExit) ? (ButtonMap.length-1) : currentStage;
        return (<div>
            {this.props.isSaving ? <div className="overlay">
                                    <Wait size="L" centered/>
                                    <span className="saving-Text">Saving</span>
                                    </div> : null }
            <StepList id="steplist-id" aria-labelledby="steplist-heading-id steplist-id" interaction="off" selectedIndex={this.props.partnerData.partnerInfo.level === "Registered" ? ContentMap['stepListRenewalRegistered'][currentStage] : ContentMap['stepListRenewal'][currentStage]}>
                
                <Step><Translate value="uplevelRenewal.OnbrdCriteriaHeaderRenewal" /></Step>
                <Step><Translate value="uplevelRenewal.ONBCompInfo" /></Step>
                <Step><Translate value="uplevelRenewal.ONBContsInfo" /></Step>
                {this.props.partnerData.partnerInfo.level === "Registered" ? null : <Step><Translate value="uplevelRenewal.SplznQuestionnaireHeader" /></Step>}
                <Step><Translate value="uplevelRenewal.ONBPgmAgreement" /></Step>
            </StepList>
            {this.state.formInitialized ? <TAG onValidateChange={this.props.onValidateChange} {...this.props} /> : null}
            {this.props.isButtonVisible ?
            <Grid>  
                <GridRow className="common-button-row">
                    <GridColumn size={[12,10,8,8]} offsetSize={[0,1,2,2]}>
                    <MakeButton btn={buttonRowNo == 0 ? 
                        (this.props.partnerData.draftLevel ? ButtonMapRenewalRegistered[buttonRowNo] : ButtonsOnDemand[0]) :
                        (this.props.partnerData.partnerInfo.level === "Registered" ? 
                            ButtonMapRenewalRegistered[buttonRowNo] : 
                            ButtonMapRenewal[buttonRowNo])
                        }
                        allbuttonFunc={allbuttonFunc} {...this.props}/>
                    </GridColumn>
                </GridRow>
            </Grid>
            : null}
        </div>);
    }
}

RenewalPage = reduxForm({
    form:'uplevelRenewal',
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })(RenewalPage);

const mapStateToProps = (state) => ({
    currentStage: state.uplevelRenewal.currentStage,
    stepListRenewal: state.uplevelRenewal.stepListRenewal,
    isSaveAndExit: state.uplevelRenewal.isSaveAndExit,
    isSaving : state.common.isSaving,
    geoPolData: state.common.geoPolData,
    isButtonVisible: state.common.isButtonVisible
  });
  
const mapDispatchToProps = (dispatch) => ({
    is_saving: (e) => dispatch(isSavingToggle(e)),
    onNextButton : () => dispatch(incrementStage()),
    onPreviousButton : () => dispatch(decrementStage()),
    onValidateChange : (bool) => dispatch(nextButtonUpdate(bool)),
    onNextBtnVisible : (bool) => dispatch(isButtonVisibleToggle(bool)),
  });
  
export default connect(mapStateToProps, mapDispatchToProps)(RenewalPage);